import React, { useContext } from 'react'
import moment, { Moment } from 'moment-timezone'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DesktopTimePicker, TimeView } from '@mui/x-date-pickers'
import { LocalizationContext } from '../../contexts'
import { uses12HourClock } from '../../../../utils/tenantDateTime'
import { RangeValue } from '../types'

interface TimeRangeFilterProps {
  label: string
  value: RangeValue
  onChange: (value: RangeValue) => void
}

const slotProps = { textField: { size: 'small' as const, fullWidth: true } }

const TimeRangeFilter: React.FC<TimeRangeFilterProps> = ({ label, value, onChange }) => {
  const { time_format } = useContext(LocalizationContext)
  const format = time_format || 'HH:mm:ss'
  const ampm = uses12HourClock(time_format)
  const views: TimeView[] = format.includes('s') ? ['hours', 'minutes', 'seconds'] : ['hours', 'minutes']

  return (
    <div>
      <label className="form-label">{label}</label>
      <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
        <div className="d-flex gap-2 align-items-center">
          <DesktopTimePicker
            value={value.from}
            maxTime={value.to ?? undefined}
            format={format}
            ampm={ampm}
            views={views}
            slotProps={slotProps}
            onChange={(from: Moment | null) => onChange({ ...value, from })}
          />
          <span className="table-filters__range-separator">-</span>
          <DesktopTimePicker
            value={value.to}
            minTime={value.from ?? undefined}
            format={format}
            ampm={ampm}
            views={views}
            slotProps={slotProps}
            onChange={(to: Moment | null) => onChange({ ...value, to })}
          />
        </div>
      </LocalizationProvider>
    </div>
  )
}

export default TimeRangeFilter
